<template>
	<div class="classRoom">
		<div class="left">
			<div class="header">
				<div class="classify" id="type">
					<p>分类：</p>
					<ul>
						<li class="buxian active" @click="queryListByType('', 0)">不限</li>
						<li v-for="(lists,key) in list" @click="queryListByType(lists.categoryId,key+1)" :title="lists.categoryName">{{lists.categoryName}}</li>
					</ul>
				</div>
				<div class="classify" id="genre">
					<p>类别：</p>
					<ul>
						<li class="buxian active" @click="queryListByCategory('',0)">不限</li>
						<li v-for="(childrens,key) in children" @click="queryListByCategory(childrens.categoryId,key+1)" :title="childrens.categoryName">{{childrens.categoryName}}</li>
					</ul>
				</div>
			</div>
			<div class="room-text">
				<p v-if="!success" class="tj-shift-notice">{{ message }}</p>
		        <template v-else-if="!categoryList.length">
		          <p class="tj-shift-notice">暂无记录</p>
		        </template>
		        <template v-else>
					<ul class="clear">
						<li v-for="list in categoryList" >
							<div class="content">
								<router-link class="tj-link-blue tj-inblock" :to="{name: 'courseDetail', params: {id: list.courseId}}">
									<div :style="style(list.iconUrl)" class="zoomImage"></div>
									<div class="text">
										<div class="title" :title="list.courseName">{{list.courseName}}</div>
										<p>
											<span class="iconfont icon-yuyue1"><i>{{list.lessonPeriod}}</i>学时</span>
											<span class="iconfont icon-people" :title="'已有'+list.totalUserNum+'人学习'">已有<i>{{list.totalUserNum}}</i>人学习</span>
										</p>
									</div>
								</router-link>
							 </div>
						</li>
					</ul>
					<pagination :pages="pages" :pageNum="pageNum" @getData="courselist"></pagination>
				</template>
			</div>
		</div>
		<div class="right">
			<div class="study">
				<h2>学习排行榜</h2>
				<ul>
					<li v-for="(infos,key) in info">
						<div class="num" :class="{'one': infos.rank === 1,'two': infos.rank === 2,'three': infos.rank === 3}">{{infos.rank}}</div>
						<p>{{infos.loginName}}</p>
						<span>{{infos.totalStudyTime}}学时</span>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				'list':'',
				"children":[],
				"childrens":[],
				"cateId":'',
				"add":'',
				"info":'',
				"nums":0,
				"roomType":'',
				'success': true,
				'message': '',
				'pageNum': 1,
				'pageSize': 12,
				'pages': 1,
				'categoryId': '',
				'categoryList':[],
				'courseList':[],
				'List':[],
				'courseName': '',
				'isActive': '',
			}
		},
		mounted:function(){
			this.Category()
			this.courselist(1)
			this.StudyInfo()
		},
		methods: {
			queryListByType:function(categoryId, key){
				this.add=categoryId
				$("#type").find("li").eq(key).addClass("active")
				$("#type").find("li").eq(key).siblings().removeClass('active')
				$("#genre").find("li").removeClass('active')
				$("#genre").find("li").eq(0).addClass("active")
				this.categoryId=categoryId
				this.pageNum=1
				var data = {
					'categoryId': this.categoryId,
					'pageNum': this.pageNum,
					'pageSize': this.pageSize
				}
				this.$http.post(API_ROOT.system+'/course/study/queryCourseList',data).then(response=>{
					this.children=[]
					var result=response.data
					if(result.success){
						this.categoryList=result.data.list != null ? result.data.list : []
						this.pageNum = result.data.pageNum == 0 ? 1 : result.data.pageNum
          				this.pages = result.data.pages == 0 ? 1 : result.data.pages
						for(var i=0;i<this.list.length;i++){
							if(this.list[i].categoryId==this.categoryId&&this.list[i].children!==null){
								for(var n=0;n<this.list[i].children.length;n++){
									this.children.push(this.list[i].children[n])
								}
							}else if(this.list[i].children!==null&& this.categoryId==0){
								for(var n=0;n<this.list[i].children.length;n++){
									this.children.push(this.list[i].children[n])
								}
							}
						}
						this.childrens=this.children
					}else {
						alert(result.msg)
					}
				},response => {
					alert('网络繁忙，请稍后重试！')
				})
			},//父级接口判断
			queryListByCategory: function(categoryId, key){
				this.pageNum=1
				if(categoryId==''){
					this.categoryId=this.add
				}else {
					this.categoryId=categoryId
				}
				$("#genre").find("li").eq(key).addClass("active")
				$("#genre").find("li").eq(key).siblings().removeClass('active')
				var data = {
					'categoryId': this.categoryId,
					'pageNum': this.pageNum,
					'pageSize': this.pageSize
				}
				this.$http.post(API_ROOT.system+'/course/study/queryCourseList',data).then(response=>{
					var result=response.data
					if(result.success){
						this.categoryList=result.data.list != null ? result.data.list : []
						this.children=this.childrens
						this.pages = result.data.pages
			            this.pageNum = result.data.pageNum == 0 ? 1 : result.data.pageNum
			          	this.pages = result.data.pages == 0 ? 1 : result.data.pages
					}else {
						alert(result.msg)
					}
				},response => {
					alert('网络繁忙，请稍后重试！')
				})
			},//子级接口判断
			Category: function(){
				this.$http.post(API_ROOT.system+'/course/study/queryCategory').then(response=>{
					var result = response.data
					if(result.success){
						this.list=result.data
						for(var i=0;i<this.list.length;i++){
							if(this.list[i].children!==null){
								for(var n=0;n<this.list[i].children.length;n++){
									this.children.push(this.list[i].children[n])
									this.childrens=this.children
								}
							}
						}
					}else {
						alert(result.msg)
					}
				},response => {
					alert('网络繁忙，请稍后重试！')
				})
			},//标题课件接口
			courselist: function(num){//课程列表
				var data= {
					"categoryId":this.categoryId,
					'pageNum': num,
					"pageSize":this.pageSize
				}
				this.$http.post(API_ROOT.system+'/course/study/queryCourseList',data).then(response=>{
					var result=response.data
					if(result.success){
						this.pages = result.data.pages
						this.pageNum = result.data.pageNum
						this.categoryList=result.data.list != null ? result.data.list : []
					}else {
						alert(result.msg)
					}
				},response => {
					alert('网络繁忙，请稍后重试！')
				})
			},//课件接口
			StudyInfo: function(){
				var param ={
					size:20
				}
				this.$http.post(API_ROOT.system+'/course/study/queryUserStudyInfo',param).then(response=>{
					var result=response.data
					if(result.success){
						this.info=result.data
					}else{
						alert(result.msg)
					}
				},response => {
					alert('网络繁忙，请稍后重试！')
				})
			},//排行榜接口
	    //设置图片
	    style(iconUrl) {
	      return {
	        backgroundImage: 'url(' + iconUrl + ')'
	      }
	    }
		}
	}
</script>



// WEBPACK FOOTER //
// ./src/page/courseList.vue